import React, { useState } from 'react';
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery
} from "@material-ui/core";
import DynamicInput from '../InputComponents/DynamicInput';
import services from '../../Services';
import moment from 'moment-timezone';
import { ReasonsTerminat } from '../TableComponents/constants';
import { DatePicker, Form, Input, Modal, Select } from 'antd';
import { useEffect } from 'react';

const { hr } = services;


const TerminatedEditModal = ({ TerminatedModal }) => {

  let { employeeDetails, open, close, mainFlag, setMainFlag } = TerminatedModal;
  const [form] = Form.useForm()

  function onUpdateTerminatedModal(values) {
    let data = {
      date: moment(values?.date).format('YYYY-MM-DD'),
      reason: values?.reason,
      comment: values?.comment,
      id: employeeDetails?.id
    }
    try {
      hr.updateEditTerminateApi(data).then(() => {
        setMainFlag(!mainFlag)
      }).catch((err) => { });
      close(false);
    }
    catch (exc) {
      close(false);
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      date: moment(employeeDetails?.terminateDate)?.utc(),
      reason: employeeDetails?.terminateReason,
      comment: employeeDetails?.terminateComment
    })
  }, [])



  return (
    <Modal
      open={open}
      onCancel={() => close(false)}
      title={"Edit termination date"}
      footer={false}
    >
      <Form
        onFinish={onUpdateTerminatedModal}
        onFinishFailed={err => console.log(err)}
        form={form}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>

          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span style={{ fontSize: "12px", fontWeight: "600" }}>Date</span>
            <Form.Item name="date" rules={[{ required: true }]}>
              <DatePicker
                allowClear={false}
                style={{ width: "100%" }}
                format={"MM-DD-YYYY"}
              />
            </Form.Item>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span style={{ fontSize: "12px", fontWeight: "600" }}>Comment</span>
            <Form.Item name="comment" rules={[{ required: true }]}>
              <Input />
            </Form.Item>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <span style={{ fontSize: "12px", fontWeight: "600" }}>Reason</span>
            <Form.Item name="reason" rules={[{ required: true }]}>
              <Select
                options={ReasonsTerminat?.map(x => { return { label: x?.title, value: x?.title } })}
                allowClear
                showSearch
              />
            </Form.Item>
          </div>


          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button type='submit' style={{ width: "50%" }} className="LinkButton">
              Save
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  )
}

export default TerminatedEditModal